import AlertInfoIcon from '@/assets/icons/alert-info-icon.svg?react';
import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiAlertStyles = {
    defaultProps: {
        iconMapping: {
            info: <AlertInfoIcon />,
        },
    },
    styleOverrides: {
        root: {
            borderRadius: '12px',
            padding: '20px',
            alignItems: 'center',
            '& .MuiTypography-root': {
                fontSize: '14px',
                fontWeight: '400',
                letterSpacing: '-0.14px',
                lineHeight: '20px',
            },
            '& .MuiAlert-message': {
                padding: '0',
            },
        },
        standardInfo: {
            backgroundColor: Palette.blue.blue50,
            color: Palette.black,
        },
    },
};
